
      var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRouterRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 54.991,
  width: 56,
  height: 17,
  rx: 4,
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 66.991a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.562 94.517c3.756-.364 9.46-2.866 15.233-7.325 6.013-4.645 10.708-11.402 11.117-14.192",
  stroke: "#9631FF",
  strokeWidth: 3.4,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m102.931 75.043 7.97-5.174 3.298 8.911",
  stroke: "#9631FF",
  strokeWidth: 3.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.972 32.781c-3.756.365-9.46 2.866-15.233 7.326-6.013 4.645-10.708 11.401-11.117 14.192",
  stroke: "#9631FF",
  strokeWidth: 3.4,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m16.605 52.28-7.97 5.173-3.299-8.911",
  stroke: "#9631FF",
  strokeWidth: 3.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M78 48.991a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM78 38.942a10.565 10.565 0 0 1 7.412 2.986 1.22 1.22 0 0 1 .269 1.39 1.259 1.259 0 0 1-.502.56 1.315 1.315 0 0 1-.754.183 1.298 1.298 0 0 1-.902-.38 7.875 7.875 0 0 0-5.525-2.252c-2.073 0-4.06.811-5.523 2.252-.251.245-.58.367-.907.367-.328 0-.657-.122-.906-.366a1.23 1.23 0 0 1-.002-1.755A10.563 10.563 0 0 1 78 38.942Z",
  fill: "#000"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M77.998 32.991c4.357.012 8.534 1.71 11.626 4.726.24.234.376.552.376.884 0 .332-.136.65-.376.884a1.3 1.3 0 0 1-.916.366c-.342.002-.671-.13-.913-.365-2.706-2.655-6.251-3.983-9.796-3.983-3.546 0-7.09 1.328-9.797 3.983a1.3 1.3 0 0 1-.914.371 1.3 1.3 0 0 1-.914-.371 1.237 1.237 0 0 1 0-1.77c3.09-3.016 7.268-4.713 11.624-4.725Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"32\" y=\"54.9912\" width=\"56\" height=\"17\" rx=\"4\" stroke=\"black\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M40.5 66.9912C38.567 66.9912 37 65.4242 37 63.4912C37 61.5582 38.567 59.9912 40.5 59.9912C42.433 59.9912 44 61.5582 44 63.4912C44 65.4242 42.433 66.9912 40.5 66.9912Z\" fill=\"black\"/>\r\n<path d=\"M83.5624 94.5175C87.3184 94.1529 93.0218 91.6514 98.7949 87.1919C104.808 82.5471 109.503 75.7904 109.912 73.0003\" stroke=\"#9631FF\" stroke-width=\"3.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M102.931 75.0426L110.901 69.8688L114.199 78.7802\" stroke=\"#9631FF\" stroke-width=\"3.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M35.9717 32.7814C32.2158 33.1459 26.5124 35.6474 20.7393 40.1069C14.7262 44.7517 10.0312 51.5084 9.62206 54.2986\" stroke=\"#9631FF\" stroke-width=\"3.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M16.6046 52.2796L8.63445 57.4535L5.33634 48.542\" stroke=\"#9631FF\" stroke-width=\"3.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M78 48.991C76.8954 48.991 76 48.0956 76 46.991C76 45.8865 76.8954 44.9911 78 44.9911C79.1045 44.9911 79.9999 45.8865 79.9999 46.991C79.9999 48.0956 79.1045 48.991 78 48.991Z\" fill=\"black\"/>\r\n<path d=\"M77.9991 38.9424C80.7752 38.9325 83.4419 40.0057 85.4124 41.9275C85.6004 42.1098 85.7216 42.3396 85.7685 42.5834C85.8152 42.826 85.7882 43.0822 85.6814 43.3182C85.5736 43.5566 85.3959 43.7492 85.1794 43.8789C84.9606 44.0099 84.7021 44.0768 84.4247 44.0613C84.0856 44.0566 83.7617 43.9211 83.5228 43.6815C82.0589 42.24 80.0714 41.429 77.9983 41.429C75.9252 41.429 73.9377 42.24 72.4746 43.6808C72.2236 43.9258 71.8954 44.0476 71.5675 44.0476C71.2396 44.0476 70.9114 43.9258 70.6615 43.6818C70.4157 43.439 70.292 43.1217 70.292 42.8039C70.292 42.4861 70.4157 42.1688 70.6604 41.9271C72.6123 40.0234 75.2487 38.9517 77.9991 38.9424Z\" fill=\"black\"/>\r\n<path d=\"M77.9979 32.9912C82.3551 33.0026 86.5325 34.7001 89.6237 37.7169C89.8637 37.9508 89.9996 38.2688 89.9996 38.6011C89.9996 38.9334 89.8637 39.2515 89.6237 39.4853C89.3809 39.7219 89.052 39.853 88.7076 39.8511C88.3658 39.853 88.0369 39.7219 87.7947 39.4859C85.0886 36.8311 81.5437 35.5029 77.9985 35.5029C74.4533 35.5029 70.9084 36.8311 68.2022 39.486C67.9498 39.734 67.6188 39.8572 67.2881 39.8572C66.9574 39.8572 66.6264 39.734 66.374 39.486C66.1252 39.2417 66 38.9216 66 38.6011C66 38.2807 66.1252 37.9606 66.3735 37.7168C69.4645 34.7001 73.6419 33.0026 77.9979 32.9912Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/routerRefresh.b66a406d8caacd141456bda86a1a74a3.svg"),
        {
          React: SvgRouterRefresh,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      